import { ICreateSketchRequest } from '../../entities/sketch/api/types';
import { EditorComponentType, GraphicType, Orientation } from '@start-set/wakadoo-editor-core';
import IPageTexture from '@start-set/wakadoo-editor-core/graphic/page/IPageTexture';
import IGraphicStructure from '@start-set/wakadoo-editor-core/graphic/IGraphicStructure';
import IComponentStructure from '@start-set/wakadoo-editor-core/components/IComponentStructure';
import { v4 as uuidv4 } from 'uuid';

export const generateEmptyTemplateStructure = (): ICreateSketchRequest => {
	const sketchId = uuidv4();
	return {
		id: sketchId,
		name: "nothing",
		root: {
			id: uuidv4(),
			type: EditorComponentType.BOOK,
			offset: null,
			texture: null,
			graphics: [{
				id: uuidv4(),
				type: GraphicType.PAGE,
				frame: null,
				texture: {
					index: 0,
					backgroundColor: "#FFFFFF",
					orientation: Orientation.PORTRAIT,
					paddingBottom: 40,
					paddingLeft: 40,
					paddingRight: 40,
					paddingTop: 40,
					backgroundImage: null,
					repeatingImage: null,
				} as IPageTexture,
			}] as IGraphicStructure<IPageTexture>[],
			components: null,
		} as IComponentStructure<null>,
		preview: null,
	};
};
